<template>
	<div class="AppAddStore">
		<!-- <div class="card-heading shinny-heading">
		</div> -->
		<span
			style="border-bottom: 2px solid orangered; padding:5px 0; font-size: 16px;"
			>Location Details</span
		>
		<div style="padding-bottom: 10px;margin: 1rem 0;">
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">
						Location Type
						<span style="color: red;">*</span>
					</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<!-- {{accountType}} -->
						<el-select
							v-model="accountType"
							v-validate="'required'"
							class="custom-input"
							placeholder="Location type"
							name="Account Type"
							style="width: 100%;"
						>
							<el-option
								v-for="(acc, index) in acc_types"
								:key="index"
								:label="acc.label"
								:value="acc.value"
							/>
						</el-select>

						<span v-show="errors.has('Account Type')" class="text-red-dark text-xs">
							{{ errors.first("Account Type") }}
						</span>
					</div>
				</el-col>

				<el-col
					:xs="24"
					:sm="12"
					:md="2"
					:lg="2"
					:xl="2"
					>&nbsp;</el-col
				>
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">
						Status
						<span style="color: red;">*</span>
					</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<el-select
							v-model="active"
							class="custom-input"
							placeholder="Account Status"
							style="width: 100%;"
							name="Account Status"
						>
							<!-- @change="popUpShow" -->
							<el-option :value="true" label="Active">Active</el-option>
							<el-option :value="false" label="In-Active">In-Active</el-option>
						</el-select>

						<span v-show="errors.has('Account Status')" class="text-red-dark text-xs">
							{{ errors.first("Account Status") }}
						</span>
					</div>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label v-if="accountType === 'store'" class="font-bold text-right input-label">
						Store Name
						<span style="color: red;">*</span>
					</label>

					<label v-if="accountType === 'region'" class="font-bold text-right input-label">
						Region Name
						<span style="color: red;">*</span>
					</label>

					<label v-if="accountType === 'subregion'" class="font-bold text-right input-label">
						Sub Region Name
						<span style="color: red;">*</span>
					</label>

					<label v-if="accountType !== 'store' && accountType !== 'region' && accountType !== 'subregion'" class="font-bold text-right input-label">
						Location Name
						<span style="color: red;">*</span>
					</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div v-if="accountType === 'store'">
						<BaseInput
							v-if="accountType === 'store'"
							key="store-input"
							v-model="accountOrStoreName"
							v-validate="accountType === 'store' ? 'required' : ''"
							class="custom-input"
							name="Store Name"
							placeholder="Store Name"
							@change="popUpShow"
						/>
						<span v-show="errors.has('Store Name')" class="text-red-dark text-xs">
							{{ errors.first("Store Name") }}
						</span>
					</div>

					<div v-if="accountType != 'store' && accountType != 'region' && accountType != 'subregion'">
						<BaseInput
							v-if="accountType != 'store' && accountType != 'region' && accountType != 'subregion'"
							key="account-input"
							v-model="accountOrStoreName"
							v-validate="accountType != 'store' && accountType != 'region' && accountType != 'subregion' ? 'required' : ''"
							class="custom-input"
							name="Account Name"
							placeholder="Location Name"
							@change="popUpShow"
						/>
						<span v-show="errors.has('Account Name')" class="text-red-dark text-xs">
							{{ errors.first("Account Name") }}
						</span>
					</div>

					<div v-if="accountType == 'region'">
						<BaseInput
							v-if="accountType == 'region'"
							key="account-input"
							v-model="region_name_txt"
							v-validate="accountType == 'region' ? 'required' : ''"
							class="custom-input"
							name="region name"
							placeholder="Enter Region Name"
							@change="popUpShow"
						/>
						<span v-show="errors.has('region name')" class="text-red-dark text-xs">
							{{ errors.first("region name") }}
						</span>
					</div>

					<div v-if="accountType === 'subregion'">
						<BaseInput
							v-if="accountType === 'subregion'"
							key="account-input"
							v-model="sub_region_name_txt"
							v-validate="accountType == 'subregion' ? 'required' : ''"
							class="custom-input"
							name="Sub Region"
							placeholder="Enter Sub Region Name"
							@change="popUpShow"
						/>
						<span v-show="errors.has('Sub Region')" class="text-red-dark text-xs">
							{{ errors.first("Sub Region") }}
						</span>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label v-if="accountType === 'store'" class="font-bold text-right input-label">
						Store Type
						<span style="color: red;">*</span>
					</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div v-if="accountType === 'store'">
						<el-select
							v-model="storeType"
							v-validate="accountType === 'store' ? 'required' : ''"
							class="custom-input"
							:disabled="accountType !== 'store'"
							style="width: 100%;"
							placeholder="Store Type"
							name="store type"
							@change="toggleStoreTypeSelection(storeType) && popUpShow"
						>
							<el-option
								v-for="(store, storeIndex) in store_types_option"
								:key="storeIndex"
								:label="store.label"
								:value="store.value"
							/>
						</el-select>

						<span v-show="errors.has('store type')" class="text-red-dark text-xs">
							{{ errors.first("store type") }}
						</span>
					</div>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<p class="font-bold input-label text-xs mt-2 pt-4" style="color:#505050;">
						Location
						<span style="color: red;">*</span>
					</p>
				</el-col>

				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<BaseInput
						v-model="search_location" id="autocomplete"
						placeholder="Location"
					/>
					<!-- <input type="text" v-model="search_location" id="autocomplete"> -->
					<!-- <ul>
						<li v-for="(result, i) in search_results" :key="i">
							{{ result }}
						</li>
					</ul> -->
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<p class="font-bold input-label text-xs mt-2 pt-4" style="color:#505050;">
						Country
						<span style="color: red;">*</span>
					</p>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<!-- :disabled="!countries.length" -->
						<BaseButton buttonclass="text-red text-xxs text-right" @click="toggleCountrySelection">
							{{ addNewCountry ? countries.length ? "Choose from existing" : "" : "Add New" }}
						</BaseButton>

						<el-select
							v-if="!addNewCountry"
							ref="country"
							v-model="country"
							v-validate="'required'"
							class="custom-input"
							style="width: 100%;"
							placeholder="Country"
							name="Country"
							@change="regionsforParticularCountry(country, 'regions') && popUpShow"
						>
							<el-option
								v-for="(country, index) in countries"
								:key="index"
								:value="country.id"
								:label="country.name"
								>{{ country.name }}</el-option
							>
						</el-select>
						<BaseInput
							v-else
							v-model="country"
							v-validate="'required'"
							class="custom-input"
							placeholder="Country"
							name="Country"
						/>
						<span
							v-show="errors.has('Country')"
							class="text-red-dark text-xs"
							>{{ errors.first("Country") }}</span
						>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<p
						class="font-bold input-label text-xs mt-2 pt-4"
						style="color:#505050;"
						v-if="accountType != 'subregion' && accountType != 'region'"
					>
						City
						<span style="color: red;">*</span>
					</p>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div v-if="accountType != 'subregion' && accountType != 'region'">
							<BaseButton
								buttonclass="text-red text-right text-xxs"
								@click="toggleCitySelection"
							>
								{{ addNewCity ? cities.length ? "Choose from existing" : "" : "Add New" }}
							</BaseButton>
						<el-select
							v-if="!addNewCity"
							v-model="city"
							v-validate="'required'"
							:filterable="true"
							class="custom-input"
							style="width: 100%;"
							placeholder="City"
							name="City"
							auto-complete="none"
							@change="popUpShow"
						>
							<el-option
								v-for="(city, index) in cities"
								:key="index"
								:value="city.id"
								:label="city.name"
							>
								{{ city.name }}
							</el-option>
						</el-select>
						<BaseInput
							v-else
							v-model="city"
							v-validate="'required'"
							class="custom-input"
							placeholder="City"
							name="City"
							auto-complete="none"
							@change="popUpShow"
						/>
						<span v-show="errors.has('City')" class="text-red-dark text-xs">
							{{ errors.first("City") }}
						</span>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label
						v-if="accountType === 'store'"
						class="font-bold text-right input-label"
					>
						Store ID
						<span style="color: red;">*</span>
					</label>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-if="accountType === 'store'"
							key="store-input"
							v-model="store_id"
							v-validate="accountType === 'store' ? 'required' : ''"
							class="custom-input"
							name="Store id"
							placeholder="Store Name"
							@change="popUpShow"
						/>
					</div>

					<span v-show="errors.has('Store id')" class="text-red-dark text-xs">
						{{errors.first("Store id") }}
					</span>
				</el-col>
			</el-row>

			<!-- v-if="accountType !== 'region' &&  accountType !== 'subregion'" -->
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col
					v-if="accountType !== 'region' && accountType !== 'head_office'"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="4"
					:xl="4"
				>
					<label class="font-bold text-right input-label">
						Region
						<span v-if="regions.length" style="color: red;">*</span>
					</label>
				</el-col>
				<el-col
					v-if="accountType !== 'region' && accountType !== 'head_office'"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="5"
					:xl="5"
				>
					<div>
						<el-select
							v-if="!addNewRegion"
							key="region-select-box"
							v-model="region"
							v-validate="regions.length ? 'required' : ''"
							:disabled="!regions.length"
							class="custom-input"
							placeholder="Region"
							style="width: 100%;"
							name="Region"
							@change="
								subRegionsforParticularRegion(region, 'subregions') && popUpShow
							"
						>
							<el-option
								v-for="(region, regionIndex) in regions"
								:key="regionIndex"
								:value="region.id"
								:label="region.name"
								>{{ region.name }}</el-option
							>
						</el-select>
						<BaseInput
							v-else
							key="region-input-box"
							v-model="region"
							:disabled="!addNewCountry && !regions.length"
							class="custom-input"
							placeholder="Region"
							:name="regions.length ? 'Region' : null"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Region')"
							class="text-red-dark text-xs"
							>{{ errors.first("Region") }}</span
						>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">
					<!-- :disabled="!regions.length" -->
					<div
						v-if="accountType !== 'region' && accountType !== 'head_office'"
						class="w-16 mt-2"
					>
						<BaseButton buttonclass="btn text-sm p-2" @click="openRegionPopUp"
							>Add</BaseButton
						>
					</div>
				</el-col>

				<el-col
					v-if="accountType !== 'subregion' && accountType !== 'region' && accountType !== 'head_office'"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="4"
					:xl="4"
				>
					<label class="font-bold text-right input-label">Sub-region</label>
				</el-col>

				<el-col
					v-if="accountType !== 'subregion' && accountType !== 'region' && accountType !== 'head_office'"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="5"
					:xl="5"
				>
					<div>
						<el-select
							v-if="!addNewSubregion"
							key="subregion-select-box"
							v-model="subregion"
							v-validate="subregions.length ? 'required' : ''"
							:disabled="!subregions.length"
							class="custom-input"
							placeholder="Subregion"
							style="width: 100%;"
							name="Subregion"
							@change="popUpShow"
						>
							<el-option
								v-for="(subregion, index) in subregions"
								:key="index"
								:value="subregion.id"
								:label="subregion.name"
								>{{ subregion.name }}</el-option
							>
						</el-select>
						<!-- :disabled="!addNewRegion && !subregions.length" -->
						<BaseInput
							v-else
							key="subregion-input-box"
							v-model="subregion"
							class="custom-input"
							placeholder="Subregion"
							name="Subregion"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Subregion')"
							class="text-red-dark text-xs"
							>{{ errors.first("Subregion") }}</span
						>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">
					<!-- :disabled="!subregions.length" -->
					<!-- <BaseButton buttonclass="btn mt-2" @click="openSubRegionPopUp">
						{{
							addNewSubregion
								? addNewCountry || addNewRegion
									? ""
									: "Choose from existing"
								: "+"
						}}
          </BaseButton>-->
					<div
						v-if="accountType !== 'region' && accountType !== 'subregion' && accountType !== 'head_office'"
						class="w-16 mt-2"
					>
						<BaseButton
							buttonclass="btn text-sm p-2 "
							@click="openSubRegionPopUp"
							>Add</BaseButton
						>
					</div>
				</el-col>
			</el-row>

			<el-row
				v-if="accountType !== 'region' && accountType !== 'subregion'"
				:gutter="20"
				class="p-2 flex items-center"
			>
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label"
						>Address(Line 1)</label
					>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<!-- <BaseInput
							v-model="addressLine1"
							class="custom-input"
							placeholder="Street Address,Company name, etc"
							@change="popUpShow"
						/> -->
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 3 }"
							placeholder="Street Address,Company name, etc"
							v-model="addressLine1"
							@change="popUpShow"
						>
						</el-input>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">Address(Line 2)</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 3 }"
							placeholder="Street Address,Company name, etc"
							v-model="addressLine2"
							@change="popUpShow"
						>
						</el-input>
						<!-- <BaseInput
							v-model="addressLine2"
							class="custom-input"
							placeholder="Street Address,Company name, etc"
							@change="popUpShow"
						/> -->
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center" v-if="accountType !== 'region' && accountType !== 'subregion'">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">Latitude</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="lattitude"
							class="custom-input"
							placeholder="Lattitude"
							name="Lattitude"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Lattitude')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Lattitude") }}
						</span>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="input-label">
						Longitude
					</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="longitude"
							class="custom-input"
							name="Longitude"
							placeholder="Longitude"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Longitude')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Longitude") }}
						</span>
					</div>
				</el-col>
			</el-row>

			<el-row
				v-if="accountType !== 'region' && accountType !== 'subregion'"
				:gutter="20"
				class="p-2 flex items-center"
			>
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">Contact No</label>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="contactNumber"
							type="number"
							class="custom-input"
							placeholder="Enter Contact Number"
							name="Contact"
							@change="popUpShow"
						/>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label
						v-if="accountType != 'region' && accountType != 'subregion'"
						class="font-bold text-right input-label"
						>Email Id</label
					>
				</el-col>

				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div v-if="accountType != 'subregion' && accountType != 'region'">
						<BaseInput
							v-model="email"
							type="email"
							class="custom-input"
							custom-class="email"
							name="Email"
							placeholder="Enter Email ID"
							@change="popUpShow"
						/>
					</div>
				</el-col>

				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col
					:xs="24"
					:sm="12"
					:md="5"
					:lg="4"
					:xl="4"
					v-if="accountType !== 'region' && accountType !== 'subregion'"
				>
					<label class="font-bold text-right input-label">
						Pin / Zip code
						<span style="color: red;">*</span>
					</label>
				</el-col>
				<el-col
					:xs="24"
					:sm="12"
					:md="5"
					:lg="5"
					:xl="5"
					v-if="accountType !== 'region' && accountType !== 'subregion'"
				>
					<div>
						<BaseInput
							v-model="pincode"
							type="number"
							class="custom-input"
							name="Pincode"
							placeholder="pincode"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Pincode')"
							class="text-red-dark text-xs"
							>{{ errors.first("Pincode") }}</span
						>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
				<el-col
					v-if="
						accountType !== 'region' &&
							accountType !== 'subregion' &&
							accountType !== 'head_office' &&
							accountType !== 'warehouse' &&
							accountType !== 'distribution_centre' &&
							accountType !== 'vendor'
					"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="4"
					:xl="4"
				>
					<label class="font-bold text-right input-label">Start Date</label>
				</el-col>
				<el-col
					v-if="
						accountType !== 'region' &&
							accountType !== 'subregion' &&
							accountType !== 'head_office' &&
							accountType !== 'warehouse' &&
							accountType !== 'distribution_centre' &&
							accountType !== 'vendor'
					"
					:xs="24"
					:sm="12"
					:md="5"
					:lg="5"
					:xl="5"
				>
					<div>
						<el-date-picker
							v-model="ordering_begin_date"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Start Date"
							default-value="2010-10-01"
							style="width: 100%"
							@change="popUpShow"
						/>
					</div>
				</el-col>
			</el-row>

			<!-- <el-row :gutter="20" class="p-2 flex items-center">
				<el-col
					v-if="
						accountType !== 'region' &&
							accountType !== 'subregion' &&
							accountType !== 'head_office' &&
							accountType !== 'warehouse' &&
							accountType !== 'central_kitchen' &&
							accountType !== 'distribution_centre' &&
							accountType !== 'vendor'
					"
					:xs="24"
					:sm="12"
					:md="2"
					:lg="2"
					:xl="2"
					>&nbsp;</el-col
				>
				<el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
			</el-row> -->
		</div>
		<!-- Rgion Popup -->
		<el-dialog
			title="Add Account - Region"
			:visible.sync="regionDialogVisible"
			width="60%"
			:before-close="handleCloseRegion"
		>
			<div class="pl-4">
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
						<div class="font-bold input-label pt-4">Region Name</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
						<div>
							<BaseInput
								v-model="region_name"
								class="custom-input"
								placeholder="Enter Region Name"
							/>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
						<div class="font-bold input-label pt-4">Select Country</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
						<div>
							<el-select
								v-model="select_country_region"
								v-validate="regionDialogVisible ? 'required' : ''"
								class="custom-input"
								placeholder="Select Country"
								name="Select Country"
								style="width: 100%;"
								@change="popUpShow"
							>
								<el-option
									v-for="(country, index) in countries"
									:key="index"
									:value="country.id"
									:label="country.name"
									>{{ country.name }}</el-option
								>
							</el-select>
						</div>
						<span
							v-show="errors.has('Select Country')"
							class="text-red-dark text-xs"
							>{{ errors.first("Select Country") }}</span
						>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="flex items-center">
							<span class="text-sm font-bold mr-2 pt-2">Add User</span>
							<div class="w-12 pt-2">
								<BaseButton
									buttonclass="p-1 btn text-sm"
									@click="openRegionUserPopup('region')"
									>Add</BaseButton
								>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<table class="w-full mt-4 text-center userTable">
				<thead>
					<tr>
						<th>Full Name</th>
						<th>Designation</th>
						<th>Email Id</th>
						<th>Mobile No</th>
						<th>Access Level</th>
						<th>Region</th>
						<th>Sub Region</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(user, index) in accountUsers" :key="index">
						<td>{{ user.full_name }} {{ user.lastName }}</td>
						<td>{{ user.designation }}</td>
						<td>{{ user.email }}</td>
						<td>{{ user.contactNumber }}</td>
						<td>{{ user.access_level }}</td>
						<td>{{ user.access_region }}</td>
						<td>{{ user.access_subregion }}</td>
					</tr>
				</tbody>
			</table>

			<div
				v-if="!accountUsers.length"
				class="text-xs text-center p-10 pb-20"
				style="color:#e29d5a"
			>
				There are currently no users added in this account type
			</div>
			<div class="flex md:justify-end align-start md:flex-row flex-col">
				<BaseButton
					class="mr-8 mt-4"
					buttonclass="btn py-2 px-4"
					@click="handleCloseRegion"
					>Cancel</BaseButton
				>
				<BaseButton
					class="mr-8 mt-4"
					buttonclass="btn py-2 px-4"
					@click="createNewRegion"
					>Update</BaseButton
				>
			</div>
		</el-dialog>

		<el-dialog
			title="Add Account - Sub Region"
			:visible.sync="subRegionDialogVisible"
			width="70%"
			:before-close="handleCloseSubRegion"
		>
			<div class="pl-6">
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
						<div class="font-bold input-label pt-4">Sub Region Name</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
						<div>
							<BaseInput
								v-model="sub_region"
								class="custom-input"
								placeholder="Enter Sub Region Name"
							/>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
						<div class="font-bold input-label pt-4">Select Country</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
						<div>
							<el-select
								v-model="select_country"
								v-validate="subRegionDialogVisible ? 'required' : ''"
								class="custom-input"
								placeholder="Select Country"
								name="Select Country"
								style="width: 100%;"
								@change="popUpShow"
							>
								<el-option
									v-for="(country, index) in countries"
									:key="index"
									:value="country.id"
									:label="country.name"
									>{{ country.name }}</el-option
								>
							</el-select>
						</div>
						<span
							v-show="errors.has('Select Country')"
							class="text-red-dark text-xs"
							>{{ errors.first("Select Country") }}</span
						>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
						<div class="font-bold input-label pt-4">Region Name</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
						<div>
							<el-select
								v-model="region"
								v-validate="subRegionDialogVisible ? 'required' : ''"
								class="custom-input"
								placeholder="Enter Region Name"
								name="Account Type"
								style="width: 100%;"
								@change="popUpShow"
							>
								<el-option
									v-for="(region, index) in regions"
									:key="index"
									:value="region.id"
									:label="region.name"
									>{{ region.name }}</el-option
								>
							</el-select>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="p-1">
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="flex items-center">
							<span class="text-sm font-bold mr-2 pt-2">Add User</span>
							<div class="w-12 pt-2">
								<BaseButton
									buttonclass=" p-1 btn text-sm"
									@click="openSubRegionUserPopup('sub_region')"
									>Add</BaseButton
								>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<table class="w-full mt-4 text-center userTable">
				<thead>
					<tr>
						<th>Full Name</th>
						<th>Designation</th>
						<th>Email Id</th>
						<th>Mobile No</th>
						<th>Access Level</th>
						<th>Region</th>
						<th>Sub Region</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(user, index) in accountUsers" :key="index">
						<td>{{ user.full_name }}</td>
						<td>{{ user.designation }}</td>
						<td>{{ user.email }}</td>
						<td>{{ user.contactNumber }}</td>
						<td>{{ user.access_level }}</td>
						<td>{{ user.access_region }}</td>
						<td>{{ user.access_subregion }}</td>
					</tr>
				</tbody>
			</table>

			<div
				v-if="!accountUsers.length"
				class="text-xs text-center p-10 pb-20"
				style="color:#e29d5a"
			>
				There are currently no users added in this account type
			</div>
			<div class="flex md:justify-end align-start md:flex-row flex-col">
				<BaseButton
					class="mr-8 mt-4"
					buttonclass="btn py-2 px-4"
					@click="handleCloseSubRegion"
					>Cancel</BaseButton
				>
				<BaseButton
					class="mr-8 mt-4"
					buttonclass="btn py-2 px-4"
					@click="createNewSubRegion"
					>Update</BaseButton
				>
			</div>
		</el-dialog>
		<!-- <div
			style="border-bottom: 1px solid #000;padding-bottom: 10px;margin: 1rem 0;"
		>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Account Type<span style="color: red;">
								*
							</span>
						</label>

						<el-select
							v-model="accountType"
							v-validate="'required'"
							class="custom-input"
							placeholder="Account type"
							name="Account Type"
							style="width: 100%;"
							@change="popUpShow"
						>
							<el-option value="store" label="Store">
								Store
							</el-option>
							<el-option value="warehouse" label="Warehouse">
								Warehouse
							</el-option>
							<el-option value="central_kitchen" label="Central Kitchen">
								Central Kitchen
							</el-option>
							<el-option value="head_office" label="Head office">
								Head Office
							</el-option>
							<el-option
								value="distribution_centre"
								label="Distribution Centre"
							>
								Distribution Centre
							</el-option>
							<el-option value="regional_office" label="Regional office">
								Regional Office
							</el-option>
							<el-option value="vendor" label="Vendor">
								Vendor
							</el-option>
						</el-select>
						<span
							v-show="errors.has('Account Type')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Account Type") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div v-if="accountType === 'store'">
							<label>
								Store Name<span style="color: red;">
									*
								</span>
							</label>
							<BaseInput
								key="store-input"
								v-model="accountOrStoreName"
								v-validate="'required'"
								class="custom-input"
								name="Store Name"
								placeholder="Store Name"
								@change="popUpShow"
							/>
						</div>
						<div v-else>
							<label>
								Account Name<span style="color: red;">
									*
								</span>
							</label>
							<BaseInput
								key="account-input"
								v-model="accountOrStoreName"
								v-validate="'required'"
								class="custom-input"
								name="Account Name"
								placeholder="Account Name"
								@change="popUpShow"
							/>
						</div>

						<span
							v-show="errors.has('Store Name')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Store Name") }}
						</span>
						<span
							v-show="errors.has('Account Name')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Account Name") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="label-parent">
							<label class="input-label">
								Store Type<span style="color: red;">
									*
								</span>
							</label>
							<BaseButton
								buttonclass="text-red text-xxs"
								@click="toggleStoreTypeSelection('Choose from existing')"
							>
								{{ addNewStoreType ? "Choose from existing" : "" }}
							</BaseButton>
						</div>
						<el-select
							v-if="!addNewStoreType"
							v-model="storeType"
							class="custom-input"
							:disabled="accountType !== 'store'"
							style="width: 100%;"
							placeholder="Store Type"
							@change="toggleStoreTypeSelection(storeType) && popUpShow"
						>
							<el-option value="Highstreet" label="Highstreet">
								Highstreet
							</el-option>
							<el-option value="Mall" label="Mall">
								Mall
							</el-option>
							<el-option value="Airport" label="Airport">
								Airport
							</el-option>
							<el-option value="Highway" label="Highway">
								Highway
							</el-option>
							<el-option value="Hospital" label="Hospital">
								Hospital
							</el-option>
							<el-option value="Others" label="Others">
								Others
							</el-option>
						</el-select>
						<BaseInput
							v-else
							v-model="storeType"
							v-validate="'required'"
							name="Store Type"
							:disabled="accountType !== 'store'"
							class="custom-input"
							placeholder="Add new store Type"
							@change="popUpShow"
						/>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="label-parent">
							<label class="input-label">
								Country<span style="color: red;">
									*
								</span>
							</label>
							<BaseButton
								buttonclass="text-red text-xxs"
								@click="toggleCountrySelection"
						<el-select
							v-if="!addNewCountry"
							ref="country"
							v-model="country"
							v-validate="'required'"
							class="custom-input"
							style="width: 100%;"
							placeholder="Country"
							name="Country"
							@change="
								regionsforParticularCountry(country, 'regions') && popUpShow
							"
						>
							<el-option
								v-for="(country, index) in countries"
								:key="index"
								:value="country.id"
								:label="country.name"
							>
								{{ country.name }}
							</el-option>
						</el-select>
						<BaseInput
							v-else
							v-model="country"
							v-validate="'required'"
							class="custom-input"
							placeholder="Country"
							name="Country"
						/>
						<span v-show="errors.has('Country')" class="text-red-dark text-xs">
							{{ errors.first("Country") }}
						</span>		>
								{{
									addNewCountry
										? countries.length
											? "Choose from existing"
											: ""
										: "Add New"
								}}
							</BaseButton>
						</div>

					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="label-parent">
							<label class="input-label">
								Region<span v-if="regions.length" style="color: red;">
									*
								</span>
							</label>
							<BaseButton
								:disabled="!regions.length"
								buttonclass="text-red text-xxs"
								@click="toggleRegionSelection"
							>
								{{
									addNewRegion
										? addNewCountry
											? ""
											: "Choose from existing"
										: "Add New"
								}}
							</BaseButton>
						</div>
						<el-select
							v-if="!addNewRegion"
							key="region-select-box"
							v-model="region"
							v-validate="regions.length ? 'required' : ''"
							:disabled="!regions.length"
							class="custom-input"
							placeholder="Region"
							style="width: 100%;"
							name="Region"
							@change="
								subRegionsforParticularRegion(region, 'subregions') && popUpShow
							"
						>
							<el-option
								v-for="(region, index) in regions"
								:key="index"
								:value="region.id"
								:label="region.name"
							>
								{{ region.name }}
							</el-option>
						</el-select>
						<BaseInput
							v-else
							key="region-input-box"
							v-model="region"
							v-validate="regions.length ? 'required' : ''"
							:disabled="!addNewCountry && !regions.length"
							class="custom-input"
							placeholder="Region"
							:name="regions.length ? 'Region' : null"
							@change="popUpShow"
						/>
						<span :v-show="errors.has('Region')" class="text-red-dark text-xs">
							{{ errors.first("Region") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="label-parent">
							<label class="input-label">
								Sub Region<span v-if="subregions.length" style="color: red;">
									*
								</span>
							</label>
							<BaseButton
								:disabled="!subregions.length"
								buttonclass="text-red text-xxs"
								@click="toggleSubregionSelection"
							>
								{{
									addNewSubregion
										? addNewCountry || addNewRegion
											? ""
											: "Choose from existing"
										: "Add New"
								}}
							</BaseButton>
						</div>
						<div>
							<el-select
								v-if="!addNewSubregion"
								key="subregion-select-box"
								v-model="subregion"
								v-validate="subregions.length ? 'required' : ''"
								:disabled="!subregions.length"
								class="custom-input"
								placeholder="Subregion"
								style="width: 100%;"
								name="Subregion"
								@change="popUpShow"
							>
								<el-option
									v-for="(subregion, index) in subregions"
									:key="index"
									:value="subregion.id"
									:label="subregion.name"
								>
									{{ subregion.name }}
								</el-option>
							</el-select>
							<BaseInput
								v-else
								key="subregion-input-box"
								v-model="subregion"
								v-validate="subregions.length ? 'required' : ''"
								:disabled="!addNewRegion && !subregions.length"
								class="custom-input"
								placeholder="Subregion"
								name="Subregion"
								@change="popUpShow"
							/>
							<span
								:v-show="errors.has('Subregion')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Subregion") }}
							</span>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="label-parent">
							<label class="input-label">
								City<span style="color: red;">
									*
								</span>
							</label>
							<BaseButton
								buttonclass="text-red text-xxs"
								@click="toggleCitySelection"
							>
								{{
									addNewCity
										? cities.length
											? "Choose from existing"
											: ""
										: "Add New"
								}}
							</BaseButton>
						</div>
						<el-select
							v-if="!addNewCity"
							v-model="city"
							v-validate="'required'"
							:filterable="true"
							class="custom-input"
							style="width: 100%;"
							placeholder="City"
							name="City"
							auto-complete="none"
							@change="popUpShow"
						>
							<el-option
								v-for="(city, index) in cities"
								:key="index"
								:value="city.id"
								:label="city.name"
							>
								{{ city.name }}
							</el-option>
						</el-select>
						<BaseInput
							v-else
							v-model="city"
							v-validate="'required'"
							class="custom-input"
							placeholder="City"
							name="City"
							auto-complete="none"
							@change="popUpShow"
						/>
						<span v-show="errors.has('City')" class="text-red-dark text-xs">
							{{ errors.first("City") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Email<span style="color: red;">
								*
							</span>
						</label>
						<BaseInput
							v-model="email"
							v-validate="'required'"
							type="email"
							class="custom-input"
							name="Email"
							placeholder="Email"
							@change="popUpShow"
						/>
						<span :v-show="errors.has('Email')" class="text-red-dark text-xs">
							{{ errors.first("Email") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Contact Number
						</label>
						<BaseInput
							v-model="contactNumber"
							type="number"
							class="custom-input"
							placeholder="Contact Number"
							name="Contact"
							@change="popUpShow"
						/>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="top-margin">
							<label class="input-label">
								Address(Line 1)
							</label>
							<BaseInput
								v-model="addressLine1"
								class="custom-input"
								placeholder="Address"
								@change="popUpShow"
							/>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Address(Line 2)
						</label>
						<BaseInput
							v-model="addressLine2"
							class="custom-input"
							placeholder="Optional"
							@change="popUpShow"
						/>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Pincode<span style="color: red;">
								*
							</span>
						</label>
						<BaseInput
							v-model="pincode"
							v-validate="'required'"
							type="number"
							class="custom-input"
							name="Pincode"
							placeholder="pincode"
							@change="popUpShow"
						/>
						<span :v-show="errors.has('Pincode')" class="text-red-dark text-xs">
							{{ errors.first("Pincode") }}
						</span>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Geo Location
						</label>
						<BaseInput
							v-model="lattitude"
							class="custom-input"
							placeholder="Lattitude"
							name="Lattitude"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Lattitude')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Lattitude") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<label class="input-label">
							Geo Location
						</label>
						<BaseInput
							v-model="longitude"
							class="custom-input"
							name="Longitude"
							placeholder="Longitude"
							@change="popUpShow"
						/>
						<span
							:v-show="errors.has('Longitude')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Longitude") }}
						</span>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="top-margin">
						<div class="mb-1">
							<label class="input-label">
								Start Date
							</label>
						</div>
						<el-date-picker
							v-model="ordering_begin_date"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Start Date"
							default-value="2010-10-01"
							style="width: 100%"
							@change="popUpShow"
						/>
					</div>
				</el-col>
			</el-row>
    </div>-->
		<!-- <div
			v-if="accountType == 'store'"
			style="border-bottom: 1px solid #ddd;padding-bottom: 10px;margin: 1rem 0;"
		>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">
						Open For Business
						<span style="color: red;">*</span>
					</label>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<el-time-select
							v-model="opening_time"
							:picker-options="{
								start: '00:00',
								step: '00:15',
								end: '23:59'
							}"
							style="width: 100%;"
							placeholder="Select time"
						>
						</el-time-select>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="1" :lg="1" :xl="1" class="text-center">
					<label class="font-bold input-label">
						To
					</label>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<el-time-select
							v-model="closing_time"
							:picker-options="{
								start: '00:00',
								step: '00:15',
								end: '23:59'
							}"
							style="width: 100%;"
							placeholder="Select time"
						>
						</el-time-select>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<el-checkbox v-model="applicable_all" @change="changeApplicable"
							>Applicable To all Days</el-checkbox
						>
					</div>
				</el-col>
			</el-row>
			<div v-if="applicable_all">
				<div v-for="(day, dayIndex) in day_parts" :key="dayIndex">
					<el-row :gutter="20" class="p-2 flex items-center">
						<el-col :xs="24" :sm="5" :md="5" :lg="4" :xl="4">
							<label class="font-bold text-right input-label">
								<span v-if="dayIndex == 0">
									Day Part
								</span>
							</label>
						</el-col>
						<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
							<div>
								<BaseInput
									v-model="day.day_part_name"
									class="custom-input"
									placeholder="Add day part"
								/>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
							<div>
								<el-time-select
									v-model="day.start_time"
									:picker-options="{
										start: '00:00',
										step: '00:15',
										end: '23:59'
									}"
									style="width: 100%;"
									placeholder="Start time"
								>
								</el-time-select>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
							<div>
								<el-time-select
									v-model="day.end_time"
									:picker-options="{
										start: '00:00',
										step: '00:15',
										end: '23:59'
									}"
									style="width: 100%;"
									placeholder="End time"
								>
								</el-time-select>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
							<div style="color:#e29d5a; font-size:25px;">
								<img
									src="../../../assets/images/delete-icon.png"
									@click="day_parts.splice(dayIndex, 1)"
									alt=""
								/>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div v-if="!applicable_all" style="height: 200px; overflow: auto;">
				<div v-for="(days, dayIndex) in allDayList" :key="dayIndex">
					<el-row class="p-2">
						<el-col :xs="24" :sm="5" :md="5" :lg="4" :xl="4">
							<label class="font-bold text-right input-label">
								<span v-if="dayIndex == 0">
									Day Part
									<span style="color: red;">*</span>
								</span>
								<span v-else>
									&nbsp;
								</span>
							</label>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
							<div class="flex">
								<span class="px-4">{{ days.name }}</span>
								<span class="px-4 text-xs text-grey">{{
									days.opening_time
								}}</span>
								<span class="text-xs text-grey">-</span>
								<span class="px-4 text-xs text-grey">{{
									days.closing_time
								}}</span>
							</div>
							<div v-for="(part, partIndex) in days.day_parts" :key="partIndex">
								<div class="flex py-2 ml-10">
									<span class="px-6 text-sm">{{ part.day_part_name }}</span>
									<span class="px-4 text-xs text-grey">{{
										part.start_time
									}}</span>
									<span class="text-xs text-grey">-</span>
									<span class="px-4 text-xs text-grey">{{
										part.end_time
									}}</span>
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
							<div style="color:#e29d5a; font-size:16px;">
								<img
									src="../../../assets/images/edit.png"
									width="20px"
									class="mr-4"
									@click="addDayPopup = true"
									alt=""
								/>
								<img
									src="../../../assets/images/delete-icon.png"
									width="20px"
									@click="allDayList.splice(dayIndex, 1)"
									alt=""
								/>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<el-row v-if="applicable_all" :gutter="20">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					&nbsp;
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<el-button
						type="warning"
						class="ml-2 px-2"
						size="small"
						@click="day_parts.push({ name: '', start_time: '', end_time: '' })"
						>Add More</el-button
					>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">
						Pre Opening Hours
						<span style="color: red;">*</span>
					</label>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="pre_opening_hour"
							type="number"
							class="custom-input"
							placeholder="Hrs"
						/>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="pre_opening_min"
							type="number"
							class="custom-input"
							placeholder="Mins"
						/>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
					<label class="font-bold text-right input-label">
						Post Closing Hours
						<span style="color: red;">*</span>
					</label>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="post_opening_hour"
							type="number"
							class="custom-input"
							placeholder="Hrs"
						/>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<div>
						<BaseInput
							v-model="post_opening_min"
							type="number"
							class="custom-input"
							placeholder="Mins"
						/>
					</div>
				</el-col>
			</el-row>
		</div> -->

		<div class="border-t" style="padding-top: 10px;">
			<span
				style="border-bottom: 2px solid orangered; padding:5px 0; font-size: 16px;"
				>User Details</span
			>
		</div>

		<div class="employee-details-table">
			<baseAccountUserDetailsTable
				:type="accountType"
				:account-id="accountId"
				:is-add-more-button="true"
				:is-account-edit="type != 'add'"
				:regions="regions"
				:sub-regions="subregions"
				:account-users="accountUsers"
				:check-popup="checkPopup"
				@addAccount="addAccount"
				@changePopupValue="changePopupValue"
				@editAccount="editAccount"
				@deleteUsersEvent="deleteUsersApiCallFn"
				@openEditBaseAccountUserPopup="openEditBaseAccountUserPopup"
			/>
		</div>

		<!-- </form> -->

		<el-dialog title="Alert !" :visible.sync="isShowPopUp">
			<span>Do you want to exit without saving the data ?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShowPopUp = false">Cancel</el-button>
				<el-button type="warning" @click="confirmBack">Confirm</el-button>
			</span>
		</el-dialog>

		<el-dialog
			title="Add New user!"
			:visible.sync="addNewUSerPopup"
			width="50%"
		>
			<BaseAccountUserDetailsPopup
				:account-type="accountType"
				:new-account-user-data="newAccountUserData"
				:account-user-index="accountUserIndex"
				:regions="regions"
				:sub-regions="subregions"
				:check-popup="checkPopup"
				@closeAddBaseAccountUserPopup="closePopup"
			/>
		</el-dialog>

		<el-dialog
			:key="editBaseAccountUserPopupKey"
			title="Edit user!"
			:visible.sync="showEditBaseAccountUserPopup"
			width="50%"
		>
			<BaseAccountUserDetailsPopup
				:account-type="accountType"
				:account-user-data="accountUserData"
				:account-user-index="accountUserIndex"
				:regions="regions"
				:sub-regions="subregions"
				:check-popup="checkPopup"
				@closeEditBaseAccountUserPopup="closePopup"
			/>
		</el-dialog>

		<el-dialog title="Add Day Part" :visible.sync="addDayPopup" width="70%">
			<div class="dayPopupBody" style="height: 400px; overflow: auto;">
				<div
					v-for="(days, dayIndex) in allDayList"
					:key="dayIndex"
					class="pb-4"
				>
					<el-row class="py-2 flex items-center">
						<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
							<label class="font-bold pl-4 input-label">
								{{ days.name }}
							</label>
						</el-col>
						<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
							<div class="px-2">
								<el-time-select
									v-model="days.opening_time"
									:picker-options="{
										start: '00:00',
										step: '00:15',
										end: '23:59'
									}"
									style="width: 100%;"
									placeholder="Select time"
								>
								</el-time-select>
							</div>
						</el-col>
						<el-col
							:xs="24"
							:sm="12"
							:md="2"
							:lg="2"
							:xl="2"
							class="text-center"
						>
							<label class="font-bold input-label">
								To
							</label>
						</el-col>
						<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
							<div class="px-2">
								<el-time-select
									v-model="days.closing_time"
									:picker-options="{
										start: '00:00',
										step: '00:15',
										end: '23:59'
									}"
									style="width: 100%;"
									placeholder="Select time"
								>
								</el-time-select>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
							<p v-if="dayIndex == 0">
								<el-button
									type="warning"
									size="mini"
									@click="setAllDaysTime(days.opening_time, days.closing_time)"
									>Set All Days</el-button
								>
							</p>
						</el-col>
					</el-row>
					<div v-for="(part, partIndex) in days.day_parts" :key="partIndex">
						<el-row class="py-2 flex items-center">
							<el-col :xs="24" :sm="5" :md="5" :lg="4" :xl="4">
								<label class="font-bold pl-4 input-label">
									<span v-if="partIndex == 0">
										Day Part
										<span style="color: red;">*</span>
									</span>
								</label>
							</el-col>
							<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
								<div class="px-2">
									<BaseInput
										v-model="part.day_part_name"
										class="custom-input"
										placeholder="Add day part"
									/>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
								<div class="px-2">
									<el-time-select
										v-model="part.start_time"
										:picker-options="{
											start: '00:00',
											step: '00:15',
											end: '23:59'
										}"
										style="width: 100%;"
										placeholder="Start time"
									>
									</el-time-select>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
								<div class="px-2">
									<el-time-select
										v-model="part.end_time"
										:picker-options="{
											start: '00:00',
											step: '00:15',
											end: '23:59'
										}"
										style="width: 100%;"
										placeholder="End time"
									>
									</el-time-select>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
								<div style="color:#e29d5a; font-size:25px;">
									<img
										src="../../../assets/images/delete-icon.png"
										alt=""
										@click="days.day_parts.splice(partIndex, 1)"
									/>
									<!-- <i
										class="el-icon-delete"
										@click="days.dayPart.splice(partIndex, 1)"
									></i> -->
								</div>
							</el-col>
						</el-row>
					</div>
					<el-row>
						<el-col :xs="24" :sm="12" :md="5" :lg="4" :xl="4">
							&nbsp;
						</el-col>
						<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5" class="p-2">
							<el-button
								type="warning"
								size="mini"
								@click="
									days.day_parts.push({
										name: '',
										start_time: '',
										end_time: ''
									})
								"
								>Add More</el-button
							>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="text-right pt-4">
				<el-button type="warning" size="mini" @click="closeDayPopup"
					>Cancel</el-button
				>
				<el-button type="warning" size="mini" @click="addDayPopup = false"
					>Update</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CommonMixin } from "../../../../mixins/common.mixin";
import CommonService from "../../../services/commonService";
import UserAccountsService from "../../../services/userAccountsService";
import { Promise, resolve, reject } from "q";
import userAccountsService from "../../../services/userAccountsService";

const userFields = [
	"full_name",
	"last_name",
	"designation",
	"designation_info",
	"email",
	"access_level",
	"access_outlet",
	"access_outlet_name",
	"phone_number",
	"status"
];

export default {
	name: "AppAddStore",

	mixins: [CommonMixin],

	props: ["accountId", "type"],

	// metaInfo () {
    //   return {
    //     script: [{
    //       src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyDEJ_HexoqCL5hUy_Eh25mNzEwGH2PDwsY&libraries=places`,
    //       async: true,
    //       defer: true,
    //       callback: () => this.MapsInit() // will declare it in methods
    //     }]
    //   }
    // },

	data: function() {
		return {
			pre_opening_hour: "",
			pre_opening_min: "",
			post_opening_hour: "",
			post_opening_min: "",
			day_parts: [
				{
					day_part_name: "",
					start_time: "",
					end_time: ""
				},
				{
					day_part_name: "",
					start_time: "",
					end_time: ""
				},
				{
					day_part_name: "",
					start_time: "",
					end_time: ""
				}
			],
			allDayList: [],
			applicable_all: true,
			opening_time: "",
			closing_time: "",
			addDayPopup: false,
			changeKeys: false,
			isShowPopUp: false,
			confirm: false,
			accountType: "",
			checkPopup: "",
			accountOrStoreName: "",
			storeType: "",
			country: "",
			region: "",
			subregion: "",
			countryId: "",
			store_id: "",
			cityId: "",
			regionId: "",
			subregionId: "",
			city: "",
			email: "",
			ordering_begin_date: "",
			contactNumber: "",
			addressLine1: "",
			addressLine2: "",
			pincode: "",
			lattitude: "",
			longitude: "",
			active: true,
			countries: [],
			regions: [],
			subregions: [],
			cities: [],
			addNewCountry: false,
			addNewCity: false,
			addNewRegion: false,
			addNewSubregion: false,
			addNewStoreType: false,
			accountUsers: [],
			newAccountUserData: {},
			addNewUSerPopup: false,
			showEditBaseAccountUserPopup: false,
			accountUserData: {},
			accountUserIndex: null,
			editBaseAccountUserPopupKey: 0,
			regionDialogVisible: false,
			subRegionDialogVisible: false,
			region_name: "",
			select_country_region: this.select_country,
			sub_region: "",
			select_country: "",
			region_name_txt: "",
			sub_region_name_txt: "",
			acc_types: [
				{
					label: "Head Office",
					value: "head_office"
				},
				{
					label: "Region",
					value: "region"
				},
				{
					label: "Sub Region",
					value: "subregion"
				},
				{
					label: "Store",
					value: "store"
				},
				{
					label: "Warehouse",
					value: "warehouse"
				},
				{
					label: "Central Kitchen",
					value: "central_kitchen"
				},
				{
					label: "Distribution Centre",
					value: "distribution_centre"
				},
				{
					label: "Vendor",
					value: "vendor"
				}
			],
			store_types_option: [
				{
					label: "Drive Through",
					value: "Drive Through"
				},
				{
					label: "Food Court",
					value: "Food Court"
				},
				{
					label: "Dine-In",
					value: "Dine-In"
				},
				{
					label: "Metro",
					value: "Metro"
				},
				{
					label: "Transit",
					value: "Transit"
				},
				// {
				// 	label: "NCF",
				// 	value: "NCF"
				// },
				// {
				// 	label: "Abbreviated",
				// 	value: "Abbreviated"
				// },
				// {
				// 	label: "SIS",
				// 	value: "SIS"
				// },
				// {
				// 	label: "Others",
				// 	value: "others"
				// }
			],
			daysInWeek: [],
			is_staff_24_hours: 2,
			staffId: null,
			search_results: [],
			search_location: '',
			autocomplete: '',
			service: null
		};
	},

	watch: {
      search_location (newValue) {
		  if (newValue) {
			// this.service.getPlacePredictions({ input: this.search_location, types: ['(cities)'] }, this.displaySuggestions)
			// console.log(newValue, this.service);
			// this.autocomplete = new google.maps.places.Autocomplete((document.getElementById('autocomplete')));
			// console.log('this.autocomplete', this.autocomplete);
			// this.autocomplete.addListener('place_changed', () => {
			// 	let place = this.autocomplete.getPlace();
			// 	let ac = place.address_components;
			// 	let lat = place.geometry.location.lat();
			// 	let lon = place.geometry.location.lng();
			// 	let city = ac[0]["short_name"];

			// 	console.log(`The user picked ${city} with the coordinates ${lat}, ${lon}`);
			// 	console.log(`place`, place);
			// });
        }
      }
    },

	computed: {
		...mapState("CommonStore", ["locations"])
		// 	return this.isChildPresent(this.country, child, this.testLocationJson);
		// }
		// addNewCountry() {
		// 	return this.countries.length ? true : false;
		// }
	},

	created() {
		this.getAllDay();
		if (this.type != "region" && this.type != "subregion" && this.type != "add") {
			this.setEditFormInfo();
			this.getLocations().then(response => {
				this.countires(this.locations);
				this.getAllRegion();
				this.getAllSubRegion();
				setTimeout(() => {
					this.regionsforParticularCountry();
					this.subRegionsforParticularRegion();
				}, 100);
			});
		} else if (this.type == "region") {
			this.getResion();
			this.getLocations().then(response => {
				this.countires(this.locations);
				setTimeout(() => {
					this.regionsforParticularCountry();
					this.subRegionsforParticularRegion();
				}, 100);
			});
		} else if (this.type == "subregion") {
			this.getSubResion();
			this.getLocations().then(response => {
				this.countires(this.locations);
				this.getAllRegion();
				// setTimeout(() => {
				// 	this.regionsforParticularCountry();
				// 	this.subRegionsforParticularRegion();
				// }, 100);
			});
		} else {
			this.getLocations().then(response => {
				this.countires(this.locations);
			});
			this.getAllRegion();
			this.getAllSubRegion();
		}

		CommonService.getCities("name", "id").then(cities => {
			this.cities = JSON.parse(cities.data);
		});
	},

	mounted(){
		// this.MapsInit();
		// this.autocomplete = new google.maps.places.Autocomplete((document.getElementById('autocomplete')));

		// this.autocomplete.addListener('place_changed', () => {
		// 	let place = this.autocomplete.getPlace();
		// 	let ac = place.address_components;
		// 	let lat = place.geometry.location.lat();
		// 	let lon = place.geometry.location.lng();
		// 	let city = ac[0]["short_name"];

		// });

		this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'));

		google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
			let place = this.autocomplete.getPlace();
			let ac = place.address_components;
			let lat = place.geometry.location.lat();
			let lon = place.geometry.location.lng();
			let city = ac[0]["short_name"];
			// console.log(lat, lon, city, ac);
			// console.log(`The user picked ${city} with the coordinates ${lat}, ${lon}`);
		});
	},

	methods: {
		MapsInit () {
			this.service = new window.google.maps.places.AutocompleteService();
			// console.log(this.service);
		},

		displaySuggestions (predictions, status) {
			if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
				this.search_results = []
				return;
			}
			this.search_results = predictions.map(prediction => prediction.description)
		},

		changeApplicable() {
			if (!this.applicable_all) {
				this.addDayPopup = true;
			} else {
				this.addDayPopup = false;
			}
		},
		closeDayPopup() {
			this.applicable_all = true;
			this.addDayPopup = false;
		},
		setAllDaysTime(start, end) {
			for (let i = 0; i < this.allDayList.length; i++) {
				this.allDayList[i].opening_time = start;
				this.allDayList[i].closing_time = end;
			}
		},
		getAllDay() {
			// let daysInWeek = [];
			userAccountsService
				.getsDays()
				.then(response => {
					this.daysInWeek = JSON.parse(response.data);
					for (let i = 1; i < 8; i++) {
						this.allDayList.push({
							day: this.daysInWeek[i].id,
							name: this.daysInWeek[i].day,
							opening_time: this.opening_time,
							closing_time: this.closing_time,
							closed: false,
							day_parts: [
								{
									day_part_name: "",
									start_time: "",
									end_time: ""
								}
							]
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		getAllRegion() {
			userAccountsService
				.getAllRegion()
				.then(response => {
					this.regions = JSON.parse(response.data);
					if(this.type == "subregion") {
						this.country = this.regions[0].country;
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		getAllSubRegion() {
			userAccountsService
				.getAllSubRegion()
				.then(response => {
					this.subregions = JSON.parse(response.data);
					if(this.type == "subregion") {

					}

				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		closePopup() {
			this.addNewUSerPopup = false;
			this.showEditBaseAccountUserPopup = false;
		},
		changePopupValue() {
			this.checkPopup = "";
		},
		...mapActions("CommonStore", ["getLocations"]),
		openRegionUserPopup(key) {
			this.checkPopup = key;
			this.accountUserIndex = null;
			this.addNewUSerPopup = true;
			this.newAccountUserData = {
				full_name: "",
				lastName: "",
				designation: "",
				email: "",
				contactNumber: "",
				access_level: "region",
				status: ""
			};
		},
		openSubRegionUserPopup(key) {
			this.checkPopup = key;
			this.accountUserIndex = null;
			this.addNewUSerPopup = true;
			this.newAccountUserData = {
				full_name: "",
				lastName: "",
				designation: "",
				email: "",
				contactNumber: "",
				access_level: "sub_region",
				status: ""
			};
		},
		deleteUsersApiCallFn(emails) {
			userAccountsService
				.deleteUsers({ data: { emails: emails } })
				.then(response => {
					// console.log("response of delete users", response);
					if (response.status === 200) {
						this.$store.commit("AccountsStore/DELETE_USERS", false);
						this.$notify.success({
							title: "Success",
							message: JSON.parse(response.data).message
						});
					}
				})
				.then(() => {
					this.accountUsers = this.accountUsers.filter(
						userAccount => emails.indexOf(userAccount.email) === -1
					);
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		getResion() {
			userAccountsService
				.getRegionOutlet(this.accountId)
				.then(response => {
					const account = JSON.parse(response.data);
					// console.log(JSON.parse(response.data));
					if (response.status === 200) {
						this.accountType = this.type;
						this.country = account.country;
						this.region = account.id;
						this.region_name_txt = account.name;
						this.city = account.city;
						this.getLocations().then(response => {
							// this.countiresArray(this.locations);
							this.regionsforParticularCountry();
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
			userAccountsService
				.getOutletWithRegionUserDetails(this.accountId, ...userFields)
				.then(response => {
					if (response.status === 200) {
						const users = JSON.parse(response.data).results;
						this.accountUsers = users.map(user => {
							return {
								full_name: user.full_name,
								lastName: user.last_name,
								designation: user.designation,
								designation_info: user.designation_info,
								email: user.email,
								contactNumber: user.phone_number,
								access_level: user.access_level,
								access_region: user.access_region,
								access_subregion: user.access_subregion,
								status: user.status
							};
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		getSubResion() {
			userAccountsService
				.getSubRegionOutlet(this.accountId)
				.then(response => {
					const account = JSON.parse(response.data);
					console
					if (response.status === 200) {
						// console.log(account);
						this.accountType = this.type;
						this.region = account.region;
						this.subregion = account.id;
						this.sub_region_name_txt = account.name;
						// this.city = account.city;
						// this.getLocations().then(response => {
						// 	// this.countiresArray(this.locations);
						// 	this.regionsforParticularCountry();
						// 	// this.subRegionsforParticularRegion();
						// 	// this.country = this.countires[0].id;
						// });
						// this.getAllSubRegion();
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
			userAccountsService
				.getOutletWithSubRegionUserDetails(this.accountId, ...userFields)
				.then(response => {
					if (response.status === 200) {
						const users = JSON.parse(response.data).results;
						this.accountUsers = users.map(user => {
							return {
								full_name: user.full_name,
								lastName: user.last_name,
								designation: user.designation,
								designation_info: user.designation_info,
								email: user.email,
								contactNumber: user.phone_number,
								access_level: user.access_level,
								access_region: user.access_region,
								access_subregion: user.access_subregion,
								status: user.status
							};
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		setEditFormInfo() {
			userAccountsService
				.getOutlet(this.accountId)
				.then(response => {
					// console.log("response", response);
					const account = JSON.parse(response.data);
					if (response.status === 200) {
						this.accountType = account.type;
						this.accountOrStoreName = account.name;
						this.storeType = account.store_type;
						this.store_id = account.store_id;
						this.country = account.country;
						this.region = account.region;
						this.subregion = account.subregion;
						this.city = account.city;
						this.email = account.email;
						this.contactNumber = account.phone;
						this.addressLine1 = account.address_line1;
						this.addressLine2 = account.address_line2;
						this.pincode = account.pincode;
						this.lattitude = account.latitude;
						this.longitude = account.longitude;
						this.ordering_begin_date = account.ordering_begin_date;
						this.active = account.active;
						this.getLocations().then(response => {
							// this.countiresArray(this.locations);
							this.regionsforParticularCountry();
							this.subRegionsforParticularRegion();
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
			userAccountsService
				.getOutletUsers(this.accountId, ...userFields)
				.then(response => {
					if (response.status === 200) {
						const users = JSON.parse(response.data).results;
						this.accountUsers = users.map(user => {
							return {
								full_name: user.full_name,
								lastName: user.last_name,
								designation: user.designation,
								designation_info: user.designation_info,
								email: user.email,
								contactNumber: user.phone_number,
								access_level: user.access_level,
								access_region: user.access_region,
								access_subregion: user.access_subregion,
								status: user.status
							};
						});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
			let params = {
				outlet_id: this.accountId
			};
			// console.log(this.type);

			// get BusinessDays api ping

			// if (this.type == "store") {
			// 	userAccountsService
			// 		.getBusinessDays(params)
			// 		.then(response => {
			// 			if (response.status === 200) {
			// 				this.allDayList = [];
			// 				let data = JSON.parse(response.data);
			// 				for (let i = 0; i < data.length - 1; i++) {
			// 					(data[i].name = this.daysInWeek[i + 1].day),
			// 						this.allDayList.push(data[i]);
			// 				}
			// 				this.applicable_all = data[data.length - 1].applicable_all;
			// 				this.opening_time = data[0].opening_time;
			// 				this.closing_time = data[0].closing_time;
			// 				if (data[data.length - 1].applicable_all) {
			// 					this.day_parts = data[0].day_parts;
			// 					if (!data[data.length - 2].day_parts.length) {
			// 						this.day_parts = [
			// 							{
			// 								day_part_name: "",
			// 								start_time: "",
			// 								end_time: ""
			// 							}
			// 						];
			// 					}
			// 				} else {
			// 					// this.allDayList = [];
			// 					// for (let i = 0; i < data.length -1; i++) {
			// 					// 	data[i].name = this.daysInWeek[i + 1].day,
			// 					// 	this.allDayList.push(data[i]);
			// 					// }
			// 				}
			// 			}
			// 		})
			// 		.catch(err => {
			// 			console.log(err);
			// 			if (!200 <= err.response.status <= 299) {
			// 				this.$notify.error({
			// 					title: "Fail",
			// 					message: "Something Went Wrong"
			// 				});
			// 			}
			// 		});
			// 	userAccountsService
			// 		.readAccountDetails(params)
			// 		.then(response => {
			// 			if (response.status === 200) {
			// 				let data = JSON.parse(response.data);
			// 				console.log(data);
			// 				this.staffId = data.id;
			// 				this.is_staff_24_hours = data.is_staff_24_hours;
			// 				if (data.is_staff_24_hours) {
			// 					[
			// 						this.pre_opening_hour,
			// 						this.pre_opening_min
			// 					] = data.pre_opening_time.split(":");
			// 					[
			// 						this.post_opening_hour,
			// 						this.post_opening_min
			// 					] = data.post_opening_time.split(":");
			// 				}
			// 			}
			// 		})
			// 		.catch(err => {
			// 			console.log(err);
			// 			if (!200 <= err.response.status <= 299) {
			// 				this.$notify.error({
			// 					title: "Fail",
			// 					message: "Something Went Wrong"
			// 				});
			// 			}
			// 		});
			// }
		},
		createCountry(country) {
			const params = {
				name: country,
				code: ""
			};
			return UserAccountsService.createCountry(params)
				.then(response => {
					if (response.data) {
						return JSON.parse(response.data).id;
					}
				})
				.catch(err => {
					// console.log(err);
					return Promise.reject(err);
				});
		},
		createRegion(region, countryId) {
			const params = {
				country: countryId,
				name: region
			};
			return UserAccountsService.createRegion(params)
				.then(response => {
					if (response.data) {
						return JSON.parse(response.data).id;
					}
				})
				.catch(err => {
					// console.log(err);
					return Promise.reject(err);
				});
		},
		// create New region in popup
		createNewRegion() {
			const params = {
				country: this.select_country_region,
				name: this.region_name
			};
			UserAccountsService.createRegion(params)
				.then(response => {
					if (response.data) {
						// console.log(JSON.parse(response.data).id);
						let id = JSON.parse(response.data).id;
						return id;
					}
				})
				.then(id => {
					const params = this.setUserAccountsParams(
						this.accountUsers,
						id,
						"new"
					);
					return UserAccountsService.createAccount(params);
				})
				.then(response => {
					// console.log("createAccount response", response);
					if (response.status === 201) {
						this.resetFormVariables();
						this.$validator.reset();
						this.$notify.success({
							title: "Success",
							message: "Account Added Successfully"
						});
						this.$router.push({ name: "AppUserPermissions" }).catch(()=>{});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		createCity(city, countryId) {
			const params = {
				name: city,
				country_code: countryId
			};
			return UserAccountsService.createCity(params)
				.then(response => {
					if (response.data) {
						return JSON.parse(response.data).id;
					}
				})
				.catch(err => {
					// console.log(err);
					return Promise.reject(err);
				});
		},
		createSubregion(subregion, regionId) {
			const params = {
				region: regionId,
				name: subregion
			};
			return UserAccountsService.createSubregion(params)
				.then(response => {
					if (response.data) {
						return JSON.parse(response.data).id;
					}
				})
				.catch(err => {
					// console.log(err);
					return Promise.reject(err);
				});
		},
		// create New Sub region in popup
		createNewSubRegion() {
			const params = {
				region: this.region,
				name: this.sub_region
			};
			UserAccountsService.createSubregion(params)
				.then(response => {
					if (response.data) {
						// console.log(JSON.parse(response.data).id);
						let id = JSON.parse(response.data).id;
						return id;
					}
				})
				.then(id => {
					const params = this.setUserAccountsParams(
						this.accountUsers,
						id,
						"new"
					);
					return UserAccountsService.createAccount(params);
				})
				.then(response => {
					// console.log("createAccount response", response);
					if (response.status === 201) {
						this.resetFormVariables();
						this.$validator.reset();
						this.$notify.success({
							title: "Success",
							message: "Account Added Successfully"
						});
						this.$router.push({ name: "AppUserPermissions" }).catch(()=>{});
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		createNewLocationsIfAny() {
			const newPromise = new Promise((resolve, reject) => {
				if (this.addNewCountry && this.country) {
					return this.createCountry(this.country)
						.then(countryId => {
							this.countryId = countryId;
							return resolve(countryId);
						})
						.catch(err => {
							return reject("Error in creating country", err);
						});
				}
				return resolve(this.country);
			});
			return newPromise
				.then(countryId => {
					if (this.addNewRegion && this.region) {
						return this.createRegion(this.region, countryId)
							.then(regionId => {
								this.regionId = regionId;
								return regionId;
							})
							.catch(err => {
								return Promise.reject(err);
							});
					}
					return this.region;
				})
				.then(regionId => {
					// console.log("regionId", regionId);
					if (this.addNewSubregion && this.subregion) {
						return this.createSubregion(this.subregion, regionId)
							.then(subregionId => {
								this.subregionId = subregionId;
								return "Done";
							})
							.catch(err => {
								return Promise.reject(err);
							});
					}
					return "Done";
				})
				.then(countryId => {
					// console.log("city132132", countryId);
					if (this.addNewCity && this.city) {
						return this.createCity(this.city, "india")
							.then(cityId => {
								// console.log("city", countryId);
								this.city = cityId;
								return this.city;
							})
							.catch(err => {
								return Promise.reject(err);
							});
					}
					return this.city;
				});
		},
		addBusinessDays(id) {
			let params = [];
			if (this.applicable_all) {
				this.allDayList = [];
				for (let j = 0; j < this.day_parts.length; j++) {
					if (this.day_parts[j].id) {
						delete this.day_parts[j].id;
					}
					this.day_parts[j].start_time = this.day_parts[j].start_time.split(
						" "
					)[0];
					this.day_parts[j].end_time = this.day_parts[j].end_time.split(" ")[0];
				}
				let day_part_list = this.day_parts.filter(e => {
					if (e.start_time && e.end_time) {
						return e;
					}
				});
				for (let i = 1; i < this.daysInWeek.length; i++) {
					this.allDayList.push({
						day: this.daysInWeek[i].id,
						opening_time: this.opening_time,
						closing_time: this.closing_time,
						closed: false,
						day_parts: day_part_list
					});
				}
				params = this.allDayList;
				// console.log(this.allDayList);
			} else {
				let allBusinessList = this.allDayList.map(e => {
					return {
						day: e.day,
						opening_time: e.opening_time,
						closing_time: e.closing_time,
						closed: e.closed,
						day_parts: e.day_parts.filter(el => {
							if (el.start_time && el.end_time) {
								return el;
							}
						})
					};
				});
				// console.log(allBusinessList);
			}
			let accountParams = {
				store: id,
				is_staff_24_hours: 1,
				pre_opening_hour: this.pre_opening_hour,
				pre_opening_min: this.pre_opening_min,
				post_opening_hour: this.post_opening_hour,
				post_opening_min: this.post_opening_min
			};
			this.staffId ? (accountParams.id = this.staffId) : "";
			UserAccountsService.addStoreDetails(accountParams)
				.then(response => {
					// console.log("createAccount response", response);
					if (response.status === 201) {
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
			UserAccountsService.addBusinessDays(id, params)
				.then(response => {
					// console.log("createAccount response", response);
					if (response.status === 201) {
						this.resetFormVariables();
						this.$validator.reset();
						this.$notify.success({
							title: "Success",
							message: "Account Added Successfully"
						});
						if (type === "continue") {
							this.$router.push({ name: "AppStoreDetails" }).catch(()=>{});
						}
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		addAccount(accountUsers, type) {
			if (this.accountType != "region" && this.accountType != "subregion") {
				this.$validator.validateAll().then(result => {
					// console.log(accountUsers, type, result);
					if (result) {
						this.createNewLocationsIfAny()
							.then(response => {
								return UserAccountsService.createOutlet({
									...this.setOutletFields()
								});
							})
							.then(response => {
								const id = JSON.parse(response.data).id;
								return id;
							})
							.then(id => {
								// if (this.accountType == "store") {
								// 	this.addBusinessDays(id);
								// }
								const params = this.setUserAccountsParams(accountUsers, id);
								return UserAccountsService.createAccount(params);
							})
							.then(response => {
								// console.log("createAccount response", response);
								if (response.status === 201) {
									this.resetFormVariables();
									this.$validator.reset();
									this.$notify.success({
										title: "Success",
										message: "Account Added Successfully"
									});
									if (type === "continue") {
										this.$router.push({ name: "AppStoreDetails" }).catch(()=>{});
									}
								}
							})
							.catch(err => {
								console.log(err);
								if (!200 <= err.response.status <= 299) {
									this.$notify.error({
										title: "Fail",
										message: "Something Went Wrong"
									});
								}
							});
					}
				});
			} else if (this.accountType == "region") {
				const params = {
					country: this.country,
					name: this.region_name_txt
				};
				UserAccountsService.createRegion(params)
					.then(response => {
						if (response.data) {
							// console.log(JSON.parse(response.data).id);
							let id = JSON.parse(response.data).id;
							return id;
						}
					})
					.then(id => {
						const params = this.setUserAccountsParams(accountUsers, id);
						return UserAccountsService.createAccount(params);
					})
					.then(response => {
						// console.log("createAccount response", response);
						if (response.status === 201) {
							this.resetFormVariables();
							this.$validator.reset();
							this.$notify.success({
								title: "Success",
								message: "Account Added Successfully"
							});
							if (type === "continue") {
								this.$router.push({ name: "AppStoreDetails" }).catch(()=>{});
							}
						}
					})
					.catch(err => {
						console.log(err);
					});
			} else if (this.accountType == "subregion") {
				const params = {
					region: this.region,
					name: this.sub_region_name_txt
				};
				UserAccountsService.createSubregion(params)
					.then(response => {
						if (response.data) {
							// console.log(JSON.parse(response.data).id);
							let id = JSON.parse(response.data).id;
							return id;
						}
					})
					.then(id => {
						const params = this.setUserAccountsParams(accountUsers, id);
						return UserAccountsService.createAccount(params);
					})
					.then(response => {
						// console.log("createAccount response", response);
						if (response.status === 201) {
							this.resetFormVariables();
							this.$validator.reset();
							this.$notify.success({
								title: "Success",
								message: "Account Added Successfully"
							});
							if (type === "continue") {
								this.$router.push({ name: "AppStoreDetails" }).catch(()=>{});
							}
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		editAccount(accountUsers, type) {
			// console.log(this.accountType);
			if (this.accountType != "region" && this.accountType != "subregion") {
				this.createNewLocationsIfAny()
					.then(response => {
						return UserAccountsService.editOutlet(this.accountId, {
							...this.setOutletFields()
						});
					})
					.then(response => {
						const id = JSON.parse(response.data).id;
						return id;
					})
					.then(id => {
						// console.log("response from editOutlet", id);
						if (id) {
							// if (this.accountType == "store") {
							// 	this.addBusinessDays(id);
							// }
							const params = this.setUserAccountsParams(accountUsers, id);
							return UserAccountsService.createAccount(params);
						}
					})
					.then(response => {
						// console.log("response from createUpdate users", response);
						if (response.status === 201) {
							this.$notify.success({
								title: "Success",
								message: "Updated Successfully"
							});
							this.$router.go(-1);
							this.confirm = true;
						}
					})
					.catch(err => {
						console.log(err);
						if (!200 <= err.response.status <= 299) {
							this.$notify.error({
								title: "Fail",
								message: "Something Went Wrong"
							});
						}
					});
			} else if (this.accountType == "region") {
				this.editRegion(accountUsers, type);
			} else if (this.accountType == "subregion") {
				this.editSubRegion(accountUsers, type);
			}
		},
		editRegion(accountUsers, type) {
			this.createNewLocationsIfAny()
				.then(response => {
					return UserAccountsService.editRegion(this.accountId, {
						...this.setOutletFields()
					});
				})
				.then(response => {
					const id = JSON.parse(response.data).id;
					return id;
				})
				.then(id => {
					// console.log("response from editOutlet", id);
					if (id) {
						const params = this.setUserAccountsParams(accountUsers, id);
						return UserAccountsService.createAccount(params);
					}
				})
				.then(response => {
					// console.log("response from createUpdate users", response);
					if (response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: "Updated Successfully"
						});
						this.$router.go(-1);
						this.confirm = true;
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		editSubRegion(accountUsers, type) {
			this.createNewLocationsIfAny()
				.then(response => {
					return UserAccountsService.editSubRegion(this.accountId, {
						...this.setOutletFields()
					});
				})
				.then(response => {
					const id = JSON.parse(response.data).id;
					return id;
				})
				.then(id => {
					// console.log("response from editOutlet", id);
					if (id) {
						const params = this.setUserAccountsParams(accountUsers, id);
						return UserAccountsService.createAccount(params);
					}
				})
				.then(response => {
					// console.log("response from createUpdate users", response);
					if (response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: "Updated Successfully"
						});
						this.$router.go(-1);
						this.confirm = true;
					}
				})
				.catch(err => {
					console.log(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		setUserAccountsParams(accountUsers, id, newRegions) {
			return accountUsers
				.filter(user => user.email !== "")
				.map(user => {
					let obj = {
						email: user.email ? user.email.toLowerCase() : user.email,
						full_name: user.full_name,
						last_name: user.lastName,
						phone_number: user.contactNumber,
						designation: user.designation,
						access_level: user.access_level
					};
					if (user.access_level == "outlet" || user.access_level == "employee" || user.access_level == "vendor") {
						obj.access_outlet = id;
					} else if (user.access_level == "region") {
						if (newRegions) {
							obj.access_region = [id];
						} else {
							obj.access_region = [
								String(user.access_region) ? String(user.access_region) : ""
							];
						}
					} else if (user.access_level == "sub_region") {
						if (newRegions) {
							obj.access_subregion = [id];
						} else {
							obj.access_subregion = [
								String(user.access_subregion)
									? String(user.access_subregion)
									: ""
							];
						}
					} else if (user.access_level == "super") {
						obj.access_country = this.select_country;
					}
					return obj;
				});
		},
		setOutletFields() {
			return this.accountType == "region"
				? {
						name: this.region_name_txt,
						country: !this.addNewCountry ? this.country : this.countryId,
						// region: !this.addNewRegion ? this.region : this.regionId,
						// city: this.city,
						active: this.active
				  }
				: this.accountType == "subregion"
				? {
						name: this.sub_region_name_txt,
						// country: !this.addNewCountry ? this.country : this.countryId,
						region: !this.addNewRegion ? this.region : this.regionId,
						// city: this.city,
						active: this.active
				  }
				: this.accountType == "store" || this.accountType == "central_kitchen"
				? {
						name: this.accountOrStoreName,
						phone: this.contactNumber,
						email: this.email ? this.email.toLowerCase() : this.email,
						type: this.accountType,
						store_type: this.storeType,
						store_id: this.store_id,
						address_line1: this.addressLine1,
						address_line2: this.addressLine2,
						pincode: this.pincode,
						country: !this.addNewCountry ? this.country : this.countryId,
						region: !this.addNewRegion ? this.region : this.regionId,
						subregion: !this.addNewSubregion
							? this.subregion
							: this.subregionId,
						city: this.city,
						active: this.active,
						ordering_begin_date: this.ordering_begin_date,
						lattitude: this.lattitude,
						longitude: this.longitude
				  }
				: {
						name: this.accountOrStoreName,
						phone: this.contactNumber,
						email: this.email ? this.email.toLowerCase() : this.email,
						type: this.accountType,
						store_type: this.storeType,
						address_line1: this.addressLine1,
						address_line2: this.addressLine2,
						pincode: this.pincode,
						country: !this.addNewCountry ? this.country : this.countryId,
						region: !this.addNewRegion ? this.region : this.regionId,
						subregion: !this.addNewSubregion
							? this.subregion
							: this.subregionId,
						city: this.city,
						active: this.active,
						lattitude: this.lattitude,
						longitude: this.longitude
				  };
		},
		resetFormVariables() {
			this.accountType = "";
			this.accountOrStoreName = "";
			this.storeType = "";
			this.country = "";
			this.region = "";
			this.subregion = "";
			this.countryId = "";
			this.regionId = "";
			this.subregionId = "";
			this.city = "";
			this.email = "";
			this.contactNumber = "";
			this.addressLine1 = "";
			this.addressLine2 = "";
			this.pincode = "";
			this.lattitude = "";
			this.longitude = "";
			this.ordering_begin_date = "";
			// this.countries = [];
			// this.cities = [];
			this.regions = [];
			this.subregions = [];
			this.addNewCountry = false;
			this.addNewRegion = false;
			this.addNewSubregion = false;
			this.addNewStoreType = false;
			this.accountUsers = [
				{
					full_name: "",
					lastName: "",
					designation: "",
					email: "",
					contactNumber: "",
					access_level: "",
					status: ""
				}
			];
		},
		toggleStoreTypeSelection(type) {
			if (type === "Others" || type === "Choose from existing") {
				this.storeType = "";
				this.addNewStoreType = !this.addNewStoreType;
			}
		},
		toggleCountrySelection() {
			this.addNewCountry = !this.addNewCountry;
			this.addNewRegion = true;
			this.addNewSubregion = true;
			this.country = "";
			this.region = "";
			this.subregion = "";
			this.regions = [];
			this.subregions = [];
		},
		toggleRegionSelection() {
			this.addNewRegion = !this.addNewRegion;
			this.addNewSubregion = true;
			this.region = "";
			this.subregion = "";
			this.subregions = [];
		},
		openRegionPopUp() {
			this.$emit("checkPopupValue");
			this.regionDialogVisible = true;
		},
		handleCloseRegion() {
			this.regionDialogVisible = false;
		},
		openSubRegionPopUp() {
			this.$emit("checkPopupValue");
			this.subRegionDialogVisible = true;
		},
		handleCloseSubRegion() {
			this.subRegionDialogVisible = false;
		},
		toggleSubregionSelection() {
			this.addNewSubregion = !this.addNewSubregion;
			this.subregion = "";
		},
		toggleCitySelection() {
			this.addNewCity = !this.addNewCity;
			this.city = "";
		},

		countires(locations) {
			locations.forEach(location => {
				if (location.type == "country") {
					this.countries.push({ name: location.name, id: location.id });
				}
			});
		},
		regionsforParticularCountry() {
			if (this.isChildPresent(this.country, "regions", this.locations)) {
				this.regions = this.getChildren(
					this.country,
					"regions",
					this.locations
				);
			} else {
				this.region = "";
				this.regions = [];
			}
		},
		subRegionsforParticularRegion() {
			if (this.isChildPresent(this.region, "subregions", this.locations)) {
				this.subregions = this.getChildren(
					this.region,
					"subregions",
					this.locations
				);
			} else {
				this.subregion = "";
				this.subregions = [];
			}
		},
		confirmBack() {
			this.isShowPopUp = false;
			this.confirm = true;
			this.$router.push({ name: "AppStoreDetails" }).catch(()=>{});
		},
		popUpShow() {
			this.changeKeys = true;
		},
		openEditBaseAccountUserPopup(employee_data, employee_index) {

			this.checkPopup = "";
			this.editBaseAccountUserPopupKey += 1; //You take this strategy of assigning keys to children, but whenever you want to re-render a component, you just update the key.
			this.showEditBaseAccountUserPopup = true;
			this.accountUserData = JSON.stringify(employee_data);
			this.accountUserIndex = employee_index;
		}
	},
	beforeRouteLeave(to, from, next) {
		// console.log(to);
		if (to.name !== "AppUserPermissions" || to.name !== "AppStoreDetails") {
			// console.log("nik", to.name);
			if (
				this.changeKeys
				// this.accountType != "" ||
				// this.accountOrStoreName != "" ||
				// this.accountOrStoreName != "" ||
				// this.country != "" ||
				// this.city != "" ||
				// this.email != "" ||
				// this.contactNumber != "" ||
				// this.accountUsers[0].full_name != "" ||
				// this.accountUsers[0].lastName != "" ||
				// this.accountUsers[0].designation != "" ||
				// this.accountUsers[0].email != "" ||
				// this.accountUsers[0].contactNumber != ""
			) {
				this.isShowPopUp = true;
			} else {
				this.confirm = true;
			}
		} else {
			this.confirm = true;
		}
		if (this.confirm) {
			next();
		} else {
			next(false);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AppAddStore.scss";
</style>

<style>
.AppAddStore .el-input {
	font-size: 12px;
}
.AppAddStore .el-dialog {
	/* width: 40%; */
	margin-top: 50px !important;
}
.AppAddStore .el-dialog__header {
	background: #32343d;
}
.AppAddStore .el-dialog__title {
	color: white;
	font-size: 15px;
	/* font-weight: 600; */
}
@media screen and (max-width: 1120px) {
	.AppAddStore .el-dialog {
		/* width: 50%; */
	}
}
.AppAddStore .el-input__inner {
	text-transform: capitalize;
}
.AppAddStore .Baseinput input {
	text-transform: capitalize;
}
.email {
	text-transform: none !important;
}
</style>
